import React from "react";
import { Paragraph } from "@tvg/design-system";
import { BetTypeDescriptionContainer } from "./styled-components";
import { BetTypeDescriptionProps } from "./types";

export const getParagraph = ({
  betTypeCode,
  isKey,
  isBox,
  isWheel,
  isSmall = false
}: BetTypeDescriptionProps) => (
  <Paragraph
    fontFamily="medium"
    fontSize={isSmall ? "xs" : "s"}
    qaLabel={`betslip-betTypeCode${isSmall ? "-subtype" : ""}`}
    color="white.900"
    textTransform={!isSmall ? "uppercase" : "capitalize"}
    textAlign="center"
    mr="space-5"
  >
    {isSmall
      ? `${isKey ? "Key " : ""}${isBox ? "Box" : ""}${isWheel ? "Wheel" : ""}`
      : betTypeCode}
  </Paragraph>
);

export const BetTypeDescription = ({
  betTypeCode,
  isKey,
  isBox,
  isWheel
}: BetTypeDescriptionProps) => (
  <BetTypeDescriptionContainer>
    {getParagraph({ betTypeCode, isKey, isBox, isWheel })}
    {(isKey || isBox || isWheel) &&
      getParagraph({ betTypeCode, isKey, isBox, isWheel, isSmall: true })}
  </BetTypeDescriptionContainer>
);
